import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'bn' ? 'en' : 'bn';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
    window.location.reload();
  };

  return (
    <button
      onClick={toggleLanguage}
      className="language-switcher"
    >
      {i18n.language === 'bn' ? 'English' : 'বাংলা'}
    </button>
  );
};

export default LanguageSwitcher;
